import { act, useEffect, useRef, useState } from "react";

import { useTheme } from "next-themes";

import JSZip from "jszip";
import Modal from "bootstrap/js/dist/modal";

import DcclLogo from "./../assets/DCCL-Logo.png";
import toast from "react-hot-toast";
import { customToast } from "../components/toasts";
import {
  customLoginButton,
  customModalCancelButton,
  customRecoverButton,
  customVerficationButton,
  themeBasedPurchaseFormControl,
  themeBasedSignupFormControl,
} from "../components/customStyles";
import { useLocation } from "react-router-dom";
import { createVerificationOTP, getInvestorVerificationDetails, handleOtpVerification } from "../services/docs-verify.service";
import DynamicOtpModal from "../components/dynamicOtpModal";
import { useAuth } from "../store/AuthContext";
import { CheckMarkIcon, WarningMarkIcon } from "../components/icons";
import { useTranslation } from "react-i18next";
import { useI18n } from "../hooks/useI18n";
import Select from "react-select";

import LogoDark from "../assets/InvestorApp.png";
import useWindowSize from "../hooks/useWindowSize";
import { getBanks, getStaticSignupData, updateInvestorDetails } from "../services/auth.service";
import { numberWithCommas } from "../utils/numbers";

function formatCNIC(value) {
  let digits = "";

  for (const x of value) {
    if (x >= "0" && x <= "9") {
      digits += x;
    }
  }

  let formatted = "";

  [...digits].forEach((x, i) => {
    if (i === 5 || i === 12) {
      formatted += "-";
    }

    formatted += x;
  });

  if (formatted.length >= 16) return formatted.slice(0, 15);

  return formatted;
}

function formatMobile(value) {
  let digits = "";

  for (const x of value) {
    if (x >= "0" && x <= "9") {
      digits += x;
    }
  }

  let formatted = "";

  [...digits].forEach((x, i) => {
    if (i === 4) {
      formatted += "-";
    }

    formatted += x;
  });

  if (formatted.length >= 13) return formatted.slice(0, 12);

  return formatted;
}

const DocumentVerification = () => {
  const [otp, setOtp] = useState("");
  const [staticData, setStaticData] = useState(() => ({
    occupations: [],
    banks: [],
  }));
  const [investorUpdateData, setInvestorUpdateData] = useState(() => ({
    account_title: "",
    account_no: "",
    bank_name: "",
    branch_name: "",
    occupation: "",
    annual_income: "",
    address: "",
  }));
  const [registerFormData, setRegisterFormData] = useState(() => ({
    salutations: "",
    name: "",
    father_name: "",
    gender: "male",
    occupation: "",
    user_email: "",
    mobile: "",
    cnic: "",
    cnic_issue: "",
    lifetime_cnic: false,
    cnic_expiry: "",
    address: "",
    city: "",
    province: "",
    country: "",
  }));

  const [registerFormErrors, setRegisterFormErrors] = useState(() => ({
    user_email: false,
    cnic: false,
    mobile: false,
  }));

  const [requiredFieldValue, setRequiredFieldValue] = useState(() => ({
    occupations: [],
    provinces: [],
    cities: [],
    countries: [],
  }));

  const [activeModal, setActiveModal] = useState(null);

  const [investorData, setInvestorData] = useState(null);

  const [uploadFiles, setUploadFiles] = useState(() => ({
    cnic_front_copy: null,
    cnic_back_copy: null,
    pay_slip: null,
    employment_letter: null,
    passport_copy: null,
    undertaking: null,
    signature_specimen: null,
  }));

  const [uploadLinks, setUploadLinks] = useState(() => ({
    cnic_front_copy: null,
    cnic_back_copy: null,
    pay_slip: null,
    employment_letter: null,
    passport_copy: null,
    undertaking: null,
    signature_specimen: null,
  }));

  const [loading, setLoading] = useState(() => ({
    email: false,
    mobile: false,
    otpEmail: false,
    otpMobile: false,
    occupations: true,
    banks: true,
    updateDocs: false,
    updateBank: false,
    updateInfo: false
  }));

  const screenSize = useWindowSize();

  const location = useLocation();

  const { theme } = useTheme();

  const { isRTL } = useI18n();

  const { t } = useTranslation();

  const { user } = useAuth();

  const dynamicModalRef = useRef();

  const updateOccupationOptions = async () => {
    const apiOptions = {
      method: "GET",
      headers: {
        Authorization: process.env.REACT_APP_API_GUEST_TOKEN,
      },
    };

    try {
      setLoading((prev) => ({ ...prev, occupations: true }));
      const occupationsSelectFormat = [];

      const occupations = await getStaticSignupData("/static/occupations", apiOptions);

      !occupations.err &&
        occupations.data.forEach((occupation) => {
          const withoutCode = occupation.slice(occupation.indexOf(" ") + 1);

          occupationsSelectFormat.push({ value: occupation, label: withoutCode });
        });

      const updatedData = occupationsSelectFormat.sort((a, b) => a.label.localeCompare(b.label));

      setStaticData((prev) => ({ ...prev, occupations: updatedData }));
    } catch (e) {
      //
    } finally {
      setLoading((prev) => ({ ...prev, occuaptions: false }));
    }
  };

  const updateBankOptions = async () => {
    try {
      setLoading((prev) => ({ ...prev, banks: true }));
      const banksSelectFormat = [];

      const response = await getBanks();

      !response.err &&
        response.data.forEach((bank) => {
          const label = `${bank.bank_name}  -  ${bank.bank_code}`;

          banksSelectFormat.push({ value: bank.bank_code, label });
        });

      const updatedData = banksSelectFormat.sort((a, b) => a.label.localeCompare(b.label));

      setStaticData((prev) => ({ ...prev, banks: updatedData }));
    } catch (e) {
      //
    } finally {
      setLoading((prev) => ({ ...prev, banks: false }));
    }
  };

  const updateFormData = (e, actionMeta) => {
    if (actionMeta) {
      const { name } = actionMeta;

      if (e) {
        setRegisterFormData((prev) => ({ ...prev, [name]: e }));
      } else {
        setRegisterFormData((prev) => ({ ...prev, [name]: "" }));
      }
    } else {
      const { name, value } = e.target;

      if (name === "cnic") {
        setRegisterFormData((prev) => ({ ...prev, [name]: formatCNIC(value) }));
      } else if (name === "mobile") {
        setRegisterFormData((prev) => ({ ...prev, [name]: formatMobile(value) }));
      } else if (name === "lifetime_cnic") {
        const { checked } = e.target;

        if (checked) {
          setRegisterFormData((prev) => ({ ...prev, cnic_expiry: "9999-12-31" }));
        } else {
          setRegisterFormData((prev) => ({ ...prev, cnic_expiry: "" }));
        }

        setRegisterFormData((prev) => ({ ...prev, [name]: checked }));
      } else {
        setRegisterFormData((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const handleFileUpload = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      // const allowedTypes = ["image/png", "image/jpeg", "application/pdf", "application/zip"];
      const allowedExts = ["png", "jpg", "jpeg", "pdf", "webp"];

      const isUnderMaxSize = (file) => {
        const maxBytes = 5 * 1024 * 1024;
        return file.size <= maxBytes;
      };

      if (!allowedExts.includes(file.name.split(".").pop().toLowerCase())) {
        toast((t) => customToast("Invalid File Type", "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
        return;
      }

      if (!isUnderMaxSize(file)) {
        toast((t) => customToast("File Size should be less than 5MB", "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
        return;
      }

      if (file.name.split(".").pop()?.toLowerCase() === "zip") {
        const arrayBuffer = await file.arrayBuffer();

        const zip = await JSZip.loadAsync(arrayBuffer);

        for (const subFile of Object.keys(zip.files)) {
          const ext = subFile.split(".").pop()?.toLowerCase() || "";

          if (!allowedExts.includes(ext)) {
            toast((t) => customToast("Zip file should include only the mentioned file types", "error", t), {
              duration: 3000,
              removeDelay: 1000,
              style: {
                padding: "0.75rem",
                margin: "0",
                minWidth: "200px",
                backgroundColor: "rgb(255,255,255)",
              },
            });

            return;
          }
        }
      }

      setUploadFiles((prev) => ({ ...prev, [e.target.id]: file }));
    }
  };

  const generateUploadPreview = (fileKey) => {
    const allowedImgExts = ["png", "jpg", "jpeg"];
    const allowedOtherExts = ["pdf", "zip"];

    const file = uploadFiles[fileKey];

    if (allowedImgExts.includes(file?.name.split(".").pop()?.toLowerCase())) {
      return "img";
    } else if (allowedOtherExts.includes(file?.name.split(".").pop()?.toLowerCase())) {
      return "obj";
    } else {
      return "img";
    }
  };

  const updateFileLinks = () => {};

  const handleVerifyAction = async (verifyType) => {
    if (verifyType === "email") {
      try {
        setLoading((prev) => ({ ...prev, email: true }));

        await new Promise((res) => setTimeout(() => res(), 2000));

        if (investorData && investorData.email_verification?.verified) {
          toast((t) => customToast("Email has already been verified.", "success", t), {
            duration: 3000,
            removeDelay: 1000,
            style: {
              padding: "0.75rem",
              margin: "0",
              minWidth: "200px",
              backgroundColor: "rgb(255,255,255)",
            },
          });

          return;
        }

        // if (!investorData?.email_verification.otp) {
        if (true) {
          const data = await createVerificationOTP(user?.data.email || location.state?.email, user?.data.amc_code || null, "email");

          if (!data.error) {
            toast((t) => customToast(data.message, "success", t), {
              duration: 3000,
              removeDelay: 1000,
              style: {
                padding: "0.75rem",
                margin: "0",
                minWidth: "200px",
                backgroundColor: "rgb(255,255,255)",
              },
            });

            setActiveModal({ title: "Verify Email", type: "email" });
          } else {
            toast((t) => customToast("Failed to generate OTP", "error", t), {
              duration: 3000,
              removeDelay: 1000,
              style: {
                padding: "0.75rem",
                margin: "0",
                minWidth: "200px",
                backgroundColor: "rgb(255,255,255)",
              },
            });
          }
        } else {
          setActiveModal({ title: "Verify Email", type: "email" });
        }
      } finally {
        setLoading((prev) => ({ ...prev, email: !prev.email }));
      }
    } else {
      toast((t) => customToast("Mobile verification is currently not supported", "error", t), {
        duration: 3000,
        removeDelay: 1000,
        style: {
          padding: "0.75rem",
          margin: "0",
          minWidth: "200px",
          backgroundColor: "rgb(255,255,255)",
        },
      });
      return;
      // try {
      //   setLoading((prev) => ({ ...prev, mobile: true }));

      //   await new Promise((res) => setTimeout(() => res(), 2000));
      //   if (investorData && investorData?.mobile_verification?.verified) {
      //     toast((t) => customToast("Mobile has already been verified.", "success", t), {
      //       duration: 3000,
      //       removeDelay: 1000,
      //       style: {
      //         padding: "0.75rem",
      //         margin: "0",
      //         minWidth: "200px",
      //         backgroundColor: "rgb(255,255,255)",
      //       },
      //     });

      //     return;
      //   }

      //   if (true) {
      //     const data = await createVerificationOTP(user?.data.email || location.state?.email, user.data.amc_code || null, "mobile");
      //     if (!data.error) {
      //       toast((t) => customToast(data.message, "success", t), {
      //         duration: 3000,
      //         removeDelay: 1000,
      //         style: {
      //           padding: "0.75rem",
      //           margin: "0",
      //           minWidth: "200px",
      //           backgroundColor: "rgb(255,255,255)",
      //         },
      //       });
      //       setActiveModal({ title: "Verify Mobile", type: "mobile" });
      //     } else {
      //       toast((t) => customToast("Failed to generate OTP", "error", t), {
      //         duration: 3000,
      //         removeDelay: 1000,
      //         style: {
      //           padding: "0.75rem",
      //           margin: "0",
      //           minWidth: "200px",
      //           backgroundColor: "rgb(255,255,255)",
      //         },
      //       });
      //     }
      //   } else {
      //     setActiveModal({ title: "Verify Mobile", type: "mobile" });
      //   }
      // } finally {
      //   setLoading((prev) => ({ ...prev, mobile: !prev.mobile }));
      // }
    }
  };

  const handleOtpModalSubmit = async (type) => {
    try {
      setLoading((prev) => ({ ...prev, [type === "email" ? "otpEmail" : "otpMobile"]: true }));

      await new Promise((res) => setTimeout(() => res(), 1000));

      const response = await handleOtpVerification(user?.data.email || location.state?.email, user?.data.amc_code || null, otp, type);

      if (!response.error) {
        await new Promise(res => setTimeout(() => res(), 250));
        await getInvestorData();
        toast((t) => customToast(response.message, "success", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });

        handleModalClose();
      } else {
        toast((t) => customToast(response.message || "Invalid OTP", "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
      }
    } finally {
      setLoading((prev) => ({ ...prev, [type === "email" ? "otpEmail" : "otpMobile"]: false }));
    }
  };

  const submitRegisterForm = (e) => {
    e.preventDefault();
  };

  const handleUpdateInvestorDocs = async () => {
    let canUpdateDocs = false;

    for (const key in uploadFiles) {
      if (uploadFiles[key]) {
        canUpdateDocs = true;
      }
    }

    if (canUpdateDocs) {
      setLoading((prev) => ({ ...prev, updateDocs: true }));

      await new Promise(res => setTimeout(() => res(), 500));

      const keyMapping = {
        cnic_front_copy: "cnic_copy_file",
        cnic_back_copy: "cnic_back_copy_file",
        pay_slip: "pay_slip_file",
        employment_letter: "employment_letter_file",
        passport_copy: "passport_copy_file",
        undertaking: "undertaking_file",
        signature_specimen: "signature_specimen_file",
      };

      const filesToUpload = {};

      for (const key in uploadFiles) {
        if (uploadFiles[key]) {
          filesToUpload[keyMapping[key]] = uploadFiles[key];
        }
      }

      const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;

      const argsData = {
        ...investorData,
        ...filesToUpload,
        email: guestEmail,
        investor_email: investorData.email,
      };

      const response = await updateInvestorDetails(argsData);

      if (!response.error) {
        await new Promise(res => setTimeout(() => res(), 250));
        await getInvestorData();
        toast((t) => customToast("Your Documents have been Updated", "success", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
        setUploadFiles(() => ({
          cnic_front_copy: null,
          cnic_back_copy: null,
          pay_slip: null,
          employment_letter: null,
          passport_copy: null,
          undertaking: null,
          signature_specimen: null
        }))
      }

      setLoading((prev) => ({ ...prev, updateDocs: false }));
    } else {
      toast((t) => customToast("You need to upload at least one file in order to update", "error", t), {
        duration: 3000,
        removeDelay: 1000,
        style: {
          padding: "0.75rem",
          margin: "0",
          minWidth: "200px",
          backgroundColor: "rgb(255,255,255)",
        },
      });
      return;
    }
  };

  const handleUpdateInvestorBank = async () => {
    let canUpdateBank = false;

    const keys = ["account_title", "account_no", "bank_name", "branch_name"];

    for (const key of keys) {
      if (key.localeCompare("bank_name") === 0) {
        const userBankNameInput = investorUpdateData[key];

        if (userBankNameInput && typeof userBankNameInput === "object" && userBankNameInput.constructor === Object) {
          if (userBankNameInput.value.localeCompare(investorData[key]) !== 0) {
            canUpdateBank = true;
            break;
          }
        } else {
          if (userBankNameInput.localeCompare(investorData[key]) !== 0) {
            canUpdateBank = true;
            break;
          }
        }
      } else {
        if (investorUpdateData[key].localeCompare(investorData[key]) !== 0) {
          canUpdateBank = true;
          break;
        }
      }
    }

    if (canUpdateBank) {
      setLoading((prev) => ({ ...prev, updateBank: true }));

      await new Promise(res => setTimeout(() => res(), 500));

      const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;

      const argsData = {
        ...investorData,
        account_title: investorUpdateData.account_title,
        account_no: investorUpdateData.account_no,
        branch_name: investorUpdateData.branch_name,
        bank_name: investorUpdateData.bank_name ? investorUpdateData.bank_name.value : "",
        email: guestEmail,
        investor_email: investorData.email,
      };

      const response = await updateInvestorDetails(argsData);

      if (!response.error) {
        await new Promise(res => setTimeout(() => res(), 250));
        await getInvestorData();
        toast((t) => customToast("Your Bank Account Information has been Updated", "success", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
      }

      setLoading((prev) => ({ ...prev, updateBank: false }));
    } else {
      toast((t) => customToast("You need to add new data or update the existing data in order to update bank account", "error", t), {
        duration: 3000,
        removeDelay: 1000,
        style: {
          padding: "0.75rem",
          margin: "0",
          minWidth: "200px",
          backgroundColor: "rgb(255,255,255)",
        },
      });
      return;
    }
  };

  const handleUpdateInvestorInfo = async () => {
    let canUpdateInfo = false;

    const keys = ["occupation", "annual_income", "address"];

    for (const key of keys) {
      if (key.localeCompare("occupation") === 0) {
        const userBankNameInput = investorUpdateData[key];

        if (userBankNameInput && typeof userBankNameInput === "object" && userBankNameInput.constructor === Object) {
          if (userBankNameInput.value.localeCompare(investorData[key]) !== 0) {
            canUpdateInfo = true;
            break;
          }
        } else {
          if (userBankNameInput.localeCompare(investorData[key]) !== 0) {
            canUpdateInfo = true;
            break;
          }
        }
      } else if (key.localeCompare("annual_income") === 0) {
        const valueIsUserTyped = typeof investorUpdateData[key] === "string" && investorUpdateData[key] !== ""
        const valueIsUserTypedButEmptyNow = typeof investorUpdateData[key] === "string" && investorUpdateData[key] === ""

        let userIncomeValue = 0;

        if (valueIsUserTyped) {
          userIncomeValue = parseFloat(investorUpdateData[key]);
        } else if (valueIsUserTypedButEmptyNow) {
          userIncomeValue = 0;
        } else {
          userIncomeValue = investorUpdateData[key];
        }

        if (userIncomeValue !== investorData[key]) {
          canUpdateInfo = true;
          break;
        }
      } else {
        if (investorUpdateData[key].localeCompare(investorData[key]) !== 0) {
          canUpdateInfo = true;
          break;
        }
      }
    }

    if (canUpdateInfo) {
      setLoading((prev) => ({ ...prev, updateInfo: true }));

      await new Promise(res => setTimeout(() => res(), 500));

      const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;

      const valueIsUserTyped = typeof investorUpdateData["annual_income"] === "string" && investorUpdateData["annual_income"] !== ""
      const valueIsUserTypedButEmptyNow = typeof investorUpdateData["annual_income"] === "string" && investorUpdateData["annual_income"] === ""

      let userIncomeValue = 0;

      if (valueIsUserTyped) {
        userIncomeValue = parseFloat(investorUpdateData["annual_income"]);
      } else if (valueIsUserTypedButEmptyNow) {
        userIncomeValue = 0;
      } else {
        userIncomeValue = investorUpdateData["annual_income"];
      }

      const argsData = {
        ...investorData,
        annual_income: userIncomeValue,
        address: investorUpdateData.address,
        occupation: investorUpdateData.occupation ? investorUpdateData.occupation.value : "",
        email: guestEmail,
        investor_email: investorData.email,
      };

      const response = await updateInvestorDetails(argsData);

      if (!response.error) {
        await new Promise(res => setTimeout(() => res(), 250));
        await getInvestorData();
        toast((t) => customToast("Your Account Information has been Updated", "success", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
      }

      setLoading((prev) => ({ ...prev, updateInfo: false }));
    } else {
      toast((t) => customToast("You need to add new data or update the existing data in order to update account information", "error", t), {
        duration: 3000,
        removeDelay: 1000,
        style: {
          padding: "0.75rem",
          margin: "0",
          minWidth: "200px",
          backgroundColor: "rgb(255,255,255)",
        },
      });
      return;
    }
  };

  const updateOtp = (e) => {
    setOtp(e.target.value);
  };

  const handleModalClose = () => {
    if (dynamicModalRef.current) {
      dynamicModalRef.current.toggle();
      setOtp("");
      setActiveModal(null);
    }
  };

  const updateInvestorData = (e, actionMeta) => {
    if (actionMeta) {
      const { name } = actionMeta;

      if (e) {
        setInvestorUpdateData((prev) => ({ ...prev, [name]: e }));
      } else {
        setInvestorUpdateData((prev) => ({ ...prev, [name]: "" }));
      }
    } else {
      const { name, value } = e.target;

      if (name === "annual_income") {
        const decimalLimit = name === "total_amount" ? 4 : 4;
        let formatted = "";

        const integerLimit = 12;

        if (value !== "") {
          let hasDecimal = false;
          let decimalCount = 0;
          let integerCount = 0;

          for (const x of value) {
            if (x === ".") {
              // allow only the first dot
              if (!hasDecimal) {
                formatted += x;
                hasDecimal = true;
              }
            } else if (x >= "0" && x <= "9") {
              if (hasDecimal) {
                // after the dot, only up to 4 digits
                if (decimalCount < decimalLimit) {
                  formatted += x;
                  decimalCount += 1;
                }
              } else {
                // before the dot, all digits allowed
                if (integerCount < integerLimit) {
                  formatted += x;
                  integerCount++;
                }
                // formatted += x;
              }
            } else if (x === ",") {
              // keep commas for now (you strip them below)
              formatted += x;
            }
            // everything else is skipped
          }
        }

        formatted = formatted.split(",").join("");

        setInvestorUpdateData((prev) => ({ ...prev, [name]: formatted }));
      } else {

        setInvestorUpdateData((prev) => ({ ...prev, [name]: value }));
      }

    }
  };

  const getInvestorData = async () => {
    if (user) {
      const response = await getInvestorVerificationDetails(user?.data.email, user?.data.amc_code);

      if (!response.error) {
        setInvestorData(response?.data);

        setInvestorUpdateData(() => {
          let updateOccupation = null;
          let updateBankName = null;

          const localOccupation = response.data?.occupation;
          const localBankName = response.data?.bank_name;

          if (localOccupation && localOccupation?.length !== 0) {
            updateOccupation = {
              value: localOccupation,
              label: localOccupation?.slice(localOccupation?.indexOf(" ") + 1),
            };
          }

          if (localBankName && localBankName?.length !== 0) {
            updateBankName = {
              value: localBankName,
              label: localBankName,
            };
          }

          return {
            ...(response?.data || {}),
            occupation: updateOccupation || "",
            bank_name: updateBankName || "",
          };
        });
      }
    } else {
    }
    // console.log(response);
  };

  useEffect(() => {
    getInvestorData();
    updateOccupationOptions();
    updateBankOptions();

    return () => {};
  }, []);

  useEffect(() => {
    // const el = dynamicModalRef.current;

    // const onHidden = () => {
    // 	setActiveModal(null);
    // 	setOtp('');
    // };

    if (dynamicModalRef.current && activeModal) {
      dynamicModalRef.current.toggle();

      // el.addEventListener('hidden.bs.modal', onHidden);
    }

    // return () => el.removeEventListener('hidden.bs.modal', onHidden);
  }, [activeModal]);

  return (
    // <div
    //   className={`add-custom-scroll${theme === "dark" ? "-dark" : ""} container-fluid w-100 d-flex mx-auto flex-column justify-content-start flex-nowrap`}
    //   style={{
    //     fontFamily: isRTL ? "var(--font-urdu)" : '"Barlow Condensed", "Kanit"',
    //     backgroundColor: "var(--theme-bg)",
    //     padding: screenSize <= 575 ? "8px 8px 8px 8px" : "4px 10px 10px 12px",
    //     borderRadius: "20px",
    //     rowGap: "8px",
    //     height: screenSize <= 575 ? "calc(100dvh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 202px)" : "calc(100dvh - 128px)",
    //     overflowY: "auto",
    //   }}
    // >
    <div
      className=''
      style={{
        borderRadius: "20px",
        backgroundColor: "var(--theme-bg)",
        height: screenSize <= 575 ? "calc(100svh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100svh - 202px)" : "calc(100svh - 128px)",
      }}
    >
      <div
        className={`row w-100 flex-column align-items-center justify-content-start mx-auto py-3 flex-nowrap add-custom-scroll${theme === "dark" ? "-dark" : ""}`}
        style={{
          // height: '100%',
          height: screenSize <= 575 ? "calc(100svh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100svh - 202px)" : "calc(100svh - 128px)",
          fontFamily: isRTL ? "var(--font-urdu)" : '"Barlow Condensed", "Kanit"',
          overflowY: "auto",
          rowGap: "8px",
          // minHeight: '700px'
        }}
      >
        <div className='col-auto p-0 text-center'>
          <img
            className=''
            src={LogoDark}
            style={{
              width: "300px",
              objectFit: "contain",
              maxWidth: "100%",
            }}
          />
        </div>

        <div className='col-12 p-0 px-2 px-sm-4'>
          {/* <div className="text-center" style={{
						lineHeight: '1',
						fontSize: '1.2rem',
						color: 'rgba(255,255,255,0.7)'
					}}>
						Login via
					</div> */}

          <div
            className='mx-auto'
            // onSubmit={submitRegisterForm}
            style={{
              marginTop: "2.5rem",
              marginBottom: "3rem",
              // minWidth: '600px',
              width: "100%",
              maxWidth: "900px",
              // backgroundColor: theme === "dark" ? "rgba(90, 90, 90, .6)" : "rgb(198, 204, 227, .48)",
              backgroundImage: "linear-gradient(120deg, var(--theme-card-secondary-bg) 0%, var(--theme-card-primary-bg) 100%)",
              color: theme === "dark" ? "rgb(210, 210, 210)" : "rgb(53, 53, 53)",
              // border: "1px solid rgba(255,255,255,.15)",
              border: "1px solid",
              borderColor: "var(--theme-card-border)",
              borderRadius: ".5rem",
              padding: screenSize >= 576 ? "1.75rem 2rem 2.5rem 2rem" : "1.75rem 1.5rem 2.5rem 1.5rem",
              // maxWidth: '100%'
            }}
          >
            <div
              className='text-center'
              style={{
                color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)",
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "1.15",
                // maxWidth: "400px",
              }}
            >
              {t("auth.verify.title.main")}
            </div>
            <div
              className='mt-4'
              style={{
                color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)",
                fontSize: "22px",
                fontWeight: "500",
                lineHeight: "1.15",
              }}
            >
              {t("auth.verify.title.user")}
            </div>
            <div
              className='row w-100 mx-auto row-cols-2 row-gap-4 flex-md-nowrap'
              style={{
                fontWeight: "400",
                marginTop: "1.75rem",
              }}
            >
              <div className='col-12 col-sm-6 p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "6px",
                  }}
                >
                  {t("auth.verify.email.label")}
                  {investorData && investorData.email_verification?.verified ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <div
                  className='d-flex w-100 justify-content-start align-items-center gap-2 flex-nowrap'
                  style={
                    {
                      // maxWidth: '100%'
                    }
                  }
                >
                  <input
                    className='form-control auth-form-control'
                    placeholder={t("auth.verify.email.placeholder")}
                    name='email'
                    disabled={true}
                    value={user?.data.email || location.state?.email}
                    type='text'
                    style={{
                      ["--bs-secondary-bg"]: theme === "light" ? "rgb(120, 119, 141)" : "rgb(190, 190, 190)",
                      border: "1px solid var(--bs-secondary-bg)",
                      color: theme === "light" ? "rgb(233, 233, 233)" : "",
                      width: screenSize >= 768 ? "278px" : "",
                      maxWidth: "100%",
                      fontSize: "1.1rem",
                    }}
                  />
                  <button
                    className='btn'
                    type='button'
                    disabled={loading.email}
                    onClick={() => handleVerifyAction("email")}
                    style={{
                      ...customVerficationButton(theme),
                      ["--bs-btn-border-color"]: theme === "light" ? "rgb(53, 123, 209)" : "rgb(203, 108, 230)",
                      ["--bs-btn-padding-x"]: "1rem",
                      fontSize: "1.1rem",
                      whiteSpace: "nowrap",
                      width: isRTL ? "auto" : "auto",
                      maxWidth: "100%",
                    }}
                  >
                    {loading.email ? (
                      <>
                        <span
                          className='spinner-border spinner-border-sm'
                          aria-hidden='true'
                          style={{
                            fontSize: "0.85rem",
                            height: "15px",
                            width: "15px",
                          }}
                        ></span>
                        {/* <span role="status">Loading...</span> */}
                      </>
                    ) : (
                      t("auth.verify.button")
                    )}
                  </button>
                </div>
              </div>
              <div className='col-12 col-sm-6 p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "6px",
                  }}
                >
                  {t("auth.verify.number.label")}
                  {investorData && investorData.mobile_verification?.verified ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <div className='d-flex w-100 mx-auto justify-content-start align-items-center gap-2 flex-nowrap'>
                  <input
                    className='form-control auth-form-control'
                    placeholder={t("auth.verify.number.placeholder")}
                    name='mobile_number'
                    disabled={true}
                    value={investorData?.mobile || location.state?.mobile_number}
                    type='text'
                    style={{
                      ["--bs-secondary-bg"]: theme === "light" ? "rgb(120, 119, 141)" : "rgb(190, 190, 190)",
                      border: "1px solid var(--bs-secondary-bg)",
                      color: theme === "light" ? "rgb(233, 233, 233)" : "",
                      width: screenSize >= 768 ? "278px" : "",
                      maxWidth: "100%",
                      fontSize: "1.1rem",
                    }}
                  />
                  <button
                    className='btn'
                    type='button'
                    disabled={loading.mobile}
                    onClick={() => handleVerifyAction("mobile")}
                    style={{
                      ...customVerficationButton(theme),
                      ["--bs-btn-border-color"]: theme === "light" ? "rgb(53, 123, 209)" : "rgb(203, 108, 230)",
                      ["--bs-btn-padding-x"]: "1rem",
                      fontSize: "1.1rem",
                      whiteSpace: "nowrap",
                      width: isRTL ? "auto" : "auto",
                      maxWidth: "100%",
                    }}
                  >
                    {loading.mobile ? (
                      <>
                        <span
                          className='spinner-border spinner-border-sm'
                          aria-hidden='true'
                          style={{
                            fontSize: "0.85rem",
                            height: "15px",
                            width: "15px",
                          }}
                        ></span>
                        {/* <span role="status">Loading...</span> */}
                      </>
                    ) : (
                      t("auth.verify.button")
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
  

            <hr className='mx-auto' style={{ width: "100%", maxWidth: "300px", marginBlock: "32px", color: theme === "light" ? "rgb(33, 37, 41)" : "rgb(134, 151, 168)" }} />
          <div
            className='mx-auto'
            // onSubmit={submitRegisterForm}
            style={{
              marginTop: "2.5rem",
              marginBottom: "3rem",
              // minWidth: '600px',
              width: "100%",
              maxWidth: "900px",
              // backgroundColor: theme === "dark" ? "rgba(90, 90, 90, .6)" : "rgb(198, 204, 227, .48)",
              backgroundImage: "linear-gradient(120deg, var(--theme-card-secondary-bg) 0%, var(--theme-card-primary-bg) 100%)",
              color: theme === "dark" ? "rgb(210, 210, 210)" : "rgb(53, 53, 53)",
              // border: "1px solid rgba(255,255,255,.15)",
              border: "1px solid",
              borderColor: "var(--theme-card-border)",
              borderRadius: ".5rem",
              padding: screenSize >= 576 ? "1.75rem 2rem 2.5rem 2rem" : "1.75rem 1.5rem 2.5rem 1.5rem",
              // maxWidth: '100%'
            }}
          >
            <div
              className='mt-0'
              style={{
                color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)",
                fontSize: "22px",
                fontWeight: "500",
                lineHeight: "1.15",
              }}
            >
              {t("auth.verify.title.docs")}
            </div>
            <div
              className='row w-100 mx-auto row-cols-sm-2 row-gap-4'
              style={{
                fontWeight: "400",
                marginTop: "2rem",
              }}
            >
              <div className='col-12 col-sm p-0'>
                {/* TITLE */}
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.front")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.cnic_copy?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='cnic_front_copy' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='cnic_front_copy'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.cnic_front_copy ? uploadFiles.cnic_front_copy.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                {/* <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  {t("auth.verify.docs.front")}{" "}
                  <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span>
                  {investorData && investorData.cnic_copy?.verified ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div> */}

                {/* INPUTS */}
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative'>
                    <input type='file' id='cnic_front_copy' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='cnic_front_copy'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.cnic_front_copy ? uploadFiles.cnic_front_copy.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.cnic_front_copy}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.cnic_front_copy ? (
                    generateUploadPreview("cnic_front_copy") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.cnic_front_copy)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                            height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.cnic_front_copy)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.cnic_copy?.file && investorData.cnic_copy?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.cnic_copy?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                          height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className='col-12 col-sm p-0'>
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.back")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.cnic_back_copy?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='cnic_back_copy' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='cnic_back_copy'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.cnic_back_copy ? uploadFiles.cnic_back_copy.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative '>
                    <input type='file' id='cnic_back_copy' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='cnic_back_copy'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.cnic_back_copy ? uploadFiles.cnic_back_copy.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.cnic_back_copy}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.cnic_back_copy ? (
                    generateUploadPreview("cnic_back_copy") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.cnic_back_copy)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                            height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.cnic_back_copy)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.cnic_back_copy?.file && investorData.cnic_back_copy?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.cnic_back_copy?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                          height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className='col-12 col-sm p-0'>
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.pay")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.pay_slip?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='pay_slip' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='pay_slip'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.pay_slip ? uploadFiles.pay_slip.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative'>
                    <input type='file' id='pay_slip' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='pay_slip'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.pay_slip ? uploadFiles.pay_slip.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.pay_slip}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.pay_slip ? (
                    generateUploadPreview("pay_slip") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.pay_slip)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                            height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.pay_slip)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.pay_slip?.file && investorData.pay_slip?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.pay_slip?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                          height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className='col-12 col-sm p-0'>
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.letter")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.employment_letter?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='employment_letter' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='employment_letter'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.employment_letter ? uploadFiles.employment_letter.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative'>
                    <input type='file' id='employment_letter' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='employment_letter'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.employment_letter ? uploadFiles.employment_letter.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.employment_letter}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.employment_letter ? (
                    generateUploadPreview("employment_letter") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.employment_letter)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                            height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.employment_letter)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.employment_letter?.file && investorData.employment_letter?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.employment_letter?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                            height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className='col-12 col-sm p-0'>
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.passport")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.passport_copy?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='passport_copy' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='passport_copy'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.passport_copy ? uploadFiles.passport_copy.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative'>
                    <input type='file' id='passport_copy' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='passport_copy'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.passport_copy ? uploadFiles.passport_copy.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.passport_copy}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.passport_copy ? (
                    generateUploadPreview("passport_copy") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.passport_copy)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                            height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.passport_copy)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.passport_copy?.file && investorData.passport_copy?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.passport_copy?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                          height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className='col-12 col-sm p-0'>
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.undertaking")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.undertaking?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='undertaking' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='undertaking'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.undertaking ? uploadFiles.undertaking.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative'>
                    <input type='file' id='undertaking' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='undertaking'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.undertaking ? uploadFiles.undertaking.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.undertaking}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.undertaking ? (
                    generateUploadPreview("undertaking") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.undertaking)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                          height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.undertaking)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.undertaking?.file && investorData.undertaking?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.undertaking?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                          height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className='col-12 col-sm p-0'>
                <div className="d-flex align-items-end flex-nowrap mb-3" style={{
                  maxWidth: '355px'
                }}>
                  <div className="flex-grow-1 flex-shrink-0 p-0">
                    <div className="d-inline-flex align-items-end justify-content-start" style={{
                      fontSize: ".9rem",
                      marginBottom: "2px",
                    }}>
                      <span className="">
                        {t("auth.verify.docs.signature")}
                      </span>
                      <span className="ms-2" style={{ paddingBottom: '3px' }}>
                        {investorData && investorData.signature_specimen?.verified ? (
                          <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                        ) : (
                          <WarningMarkIcon width={18} height={18} color='#ffc107' />
                        )}
                      </span>
                    </div>
                    <div className="" style={{
                      fontSize: ".8rem",
                      color: theme === "light" ? "rgb(39, 102, 179)" : "rgba(197, 120, 203, 1)"
                    }}>
                      {"(PNG, JPG, JPEG, PDF, WEBP)"}
                    </div>
                  </div>
                  <div className='flex-grow-0 flex-shrink-0 p-0 position-relative'>
                    <input type='file' id='signature_specimen' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='signature_specimen'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.signature_specimen ? uploadFiles.signature_specimen.name : t("auth.verify.file")}
                    </label>
                  </div>
                </div>
                <div className='row w-100 mx-auto justify-content-start align-items-center pe-md-4 gap-3'>
                  {/* <div className='col-auto p-0 position-relative'>
                    <input type='file' id='signature_specimen' className='custom-file-input' onChange={handleFileUpload} />
                    <label
                      htmlFor='signature_specimen'
                      className='custom-file-label form-control text-truncate pe-3'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        fontSize: "1.1rem",
                        width: screenSize >= 576 ? "110px" : "",
                        maxWidth: screenSize >= 576 ? "100%" : "96px",
                      }}
                    >
                      {uploadFiles.signature_specimen ? uploadFiles.signature_specimen.name : t("auth.verify.file")}
                    </label>
                  </div> */}
                  {/* <div className='col-auto p-0'>
                    <div
                      className=''
                      style={{
                        fontSize: "1rem",
                        color: theme === "light" ? "rgba(75, 75, 75, .6)" : "rgba(255,255,255,.6)",
                        fontWeight: "500",
                      }}
                    >
                      {t("auth.verify.or")}
                    </div>
                  </div>
                  <div className='col col-sm-auto p-0'>
                    <input
                      className='form-control auth-form-control'
                      placeholder={t("auth.verify.link")}
                      name='cnic_front_link'
                      value={uploadLinks.signature_specimen}
                      onChange={updateFileLinks}
                      type='text'
                      style={{
                        ...themeBasedSignupFormControl(theme),
                        // border: '1px solid rgb(250, 229, 255)',
                        width: screenSize >= 576 ? "200px" : "100%",
                        maxWidth: "100%",
                        fontSize: "1.1rem",
                      }}
                    />
                  </div> */}
                  {uploadFiles.signature_specimen ? (
                    generateUploadPreview("signature_specimen") === "img" ? (
                      <div className='col-12 p-0'>
                        <img
                          className='img-fluid'
                          src={URL.createObjectURL(uploadFiles.signature_specimen)}
                          alt='preview'
                          style={{
                            // backgroundColor: 'white'
                            maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                            width: "100%",
                            height: '200px',
                            objectFit: "contain",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ) : (
                      <object
                        className='p-0'
                        data={URL.createObjectURL(uploadFiles.signature_specimen)}
                        type='application/pdf'
                        width='100%'
                        height='200px'
                        style={{
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                        }}
                      ></object>
                    )
                  ) : investorData && investorData.signature_specimen?.file && investorData.signature_specimen?.file?.length !== 0 ? (
                    <div className='col-12 p-0'>
                      <img
                        className='img-fluid'
                        src={investorData.signature_specimen?.file}
                        alt='preview'
                        style={{
                          // backgroundColor: 'white'
                          maxWidth: screenSize >= 576 ? "calc(100% - 38px)" : "100%",
                          width: "100%",
                          height: '200px',
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div
              className='d-flex align-items-center justify-content-end mt-5'
              style={{
                paddingInlineEnd: "60px",
              }}
            >
              <button
                className='btn d-flex align-items-center justify-content-center px-3 gap-2'
                type='button'
                disabled={loading.updateDocs}
                onClick={handleUpdateInvestorDocs}
                style={{
                  ...customLoginButton,
                  minWidth: "112px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  letterSpacing: "0.02em",
                }}
              >
                {loading.updateDocs ? (
                  <>
                    <span
                      className='spinner-border spinner-border-sm'
                      aria-hidden='true'
                      style={{
                        fontSize: "0.85rem",
                        height: "15px",
                        width: "15px",
                      }}
                    ></span>
                    <span role='status' className='ms-1'>
                      Updating ...
                    </span>
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>

            <hr className='mx-auto' style={{ width: "100%", maxWidth: "300px", marginBlock: "32px", color: theme === "light" ? "rgb(33, 37, 41)" : "rgb(134, 151, 168)" }} />

          <div
            className='mx-auto'
            // onSubmit={submitRegisterForm}
            style={{
              marginTop: "2.5rem",
              marginBottom: "3rem",
              // minWidth: '600px',
              width: "100%",
              maxWidth: "900px",
              // backgroundColor: theme === "dark" ? "rgba(90, 90, 90, .6)" : "rgb(198, 204, 227, .48)",
              backgroundImage: "linear-gradient(120deg, var(--theme-card-secondary-bg) 0%, var(--theme-card-primary-bg) 100%)",
              color: theme === "dark" ? "rgb(210, 210, 210)" : "rgb(53, 53, 53)",
              // border: "1px solid rgba(255,255,255,.15)",
              border: "1px solid",
              borderColor: "var(--theme-card-border)",
              borderRadius: ".5rem",
              padding: screenSize >= 576 ? "1.75rem 2rem 2.5rem 2rem" : "1.75rem 1.5rem 2.5rem 1.5rem",
              // maxWidth: '100%'
            }}
          >
            <div
              className='mt-0'
              style={{
                color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)",
                fontSize: "22px",
                fontWeight: "500",
                lineHeight: "1.15",
              }}
            >
              Bank Account
            </div>
            <div
              className='row w-100 mx-auto row-cols-sm-2 row-gap-4'
              style={{
                fontWeight: "400",
                marginTop: "2rem",
              }}
            >
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Account Title
                  {investorData && investorData.account_title && investorData.account_title?.length !== 0 ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <input
                  className='form-control auth-form-control'
                  placeholder={"Enter Account Title"}
                  name='account_title'
                  // disabled={(investorData && investorData.account_title && investorData.account_title?.length !== 0)}
                  value={investorUpdateData?.account_title || ""}
                  onChange={updateInvestorData}
                  type='text'
                  style={{
                    ...themeBasedSignupFormControl(theme),
                    // border: '1px solid rgb(250, 229, 255)',
                    // width: screenSize >= 576 ? "200px" : "100%",
                    maxWidth: "100%",
                    fontSize: "1.1rem",
                  }}
                />
              </div>
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Account No
                  {/* <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span> */}
                  {investorData && investorData.account_no && investorData.account_no?.length !== 0 ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <input
                  className='form-control auth-form-control'
                  placeholder={"Enter Account No"}
                  name='account_no'
                  // disabled={(investorData && investorData.account_no && investorData.account_no?.length !== 0)}
                  value={investorUpdateData?.account_no || ""}
                  onChange={updateInvestorData}
                  type='text'
                  style={{
                    ...themeBasedSignupFormControl(theme),
                    // border: '1px solid rgb(250, 229, 255)',
                    // width: screenSize >= 576 ? "200px" : "100%",
                    maxWidth: "100%",
                    fontSize: "1.1rem",
                  }}
                />
              </div>
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Bank Name
                  {/* <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span> */}
                  {investorData && investorData.bank_name && investorData.bank_name?.length !== 0 ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <Select
                  className='basic-single'
                  classNamePrefix='select'
                  name='bank_name'
                  defaultValue={""}
                  value={investorUpdateData?.bank_name || ""}
                  onChange={updateInvestorData}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  options={staticData.banks}
                  styles={{
                    multiValue: (provided) => ({
                      ...provided,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
                    }),
                    clearIndicator: (provided, state) => ({
                      ...provided,
                      color: state.isFocused
                        ? theme === "light"
                          ? "rgb(200,200,200)"
                          : "rgb(144, 144, 144)"
                        : theme === "light"
                          ? "rgba(240, 240, 240, .65)"
                          : "rgb(184, 184, 184)",
                      "&:hover": {
                        color: state.isFocused
                          ? theme === "light"
                            ? "rgb(240,240,240)"
                            : "rgb(105, 105, 105)"
                          : theme === "light"
                            ? "rgba(240, 240, 240, .85)"
                            : "rgb(153, 153, 153)",
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: theme === "dark" ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
                    }),
                    control: (provided, state) => ({
                      ...provided,
                      minHeight: "40px",
                      // width: '120px',
                      // maxWidth: '120px',
                      backgroundColor: theme === "dark" ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
                      borderColor: theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
                      color: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
                      borderRadius: ".375rem",
                      fontFamily: "inherit",
                      boxShadow: state.isFocused
                        ? `0 0 2px 1px ${theme === "light" ? "rgba(136, 136, 136, 0.5)" : "rgba(136, 136, 136, 0.5)"}` // e.g. a semi-transparent red ring
                        : "none",
                      "&:hover": {
                        borderColor: theme === "dark" ? "rgb(156, 155, 156)" : "rgb(174, 172, 175)",
                      },
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
                    }),
                    dropdownIndicator: (provided, state) => ({
                      ...provided,
                      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined,
                      transition: "all 0.2s ease",
                      color: state.isFocused
                        ? theme === "light"
                          ? "rgb(200,200,200)"
                          : "rgb(144, 144, 144)"
                        : theme === "light"
                          ? "rgba(240, 240, 240, .65)"
                          : "rgb(184, 184, 184)",
                      "&:hover": {
                        color: state.isFocused
                          ? theme === "light"
                            ? "rgb(240,240,240)"
                            : "rgb(105, 105, 105)"
                          : theme === "light"
                            ? "rgba(240, 240, 240, .85)"
                            : "rgb(153, 153, 153)",
                      },
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: theme === "dark" ? "rgba(0, 0, 0, 0.4)" : "rgba(240, 240, 240, .65)",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      // backgroundColor: theme === 'dark' ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
                      borderRadius: 4,
                      padding: 0,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: state.isSelected ? (theme === "light" ? "rgb(250,250,250)" : "rgb(240,240,240)") : theme === "light" ? "rgba(240, 240, 240, .95)" : "rgb(33,37,41)",
                      backgroundColor: state.isSelected
                        ? theme === "light"
                          ? "rgb(203, 110, 209)"
                          : "rgb(44, 106, 182)"
                        : theme === "light"
                          ? "rgb(107, 106, 138)"
                          : "rgb(230, 230, 230)",
                      fontWeight: "400",
                      "&:hover": {
                        cursor: "pointer",
                        backgroundColor: state.isSelected ? "" : theme === "light" ? "rgb(230, 230, 230)" : "rgb(200, 200, 200)",
                        color: state.isSelected ? "" : theme === "light" ? "rgb(33,37,41)" : "",
                      },
                    }),
                  }}
                />
              </div>
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Branch Name
                  {/* <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span> */}
                  {investorData && investorData.branch_name && investorData.branch_name?.length !== 0 ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <input
                  className='form-control auth-form-control'
                  placeholder={"Enter Branch Name"}
                  name='branch_name'
                  // disabled={(investorData && investorData.branch_name && investorData.branch_name?.length !== 0)}
                  value={investorUpdateData?.branch_name || ""}
                  onChange={updateInvestorData}
                  type='text'
                  style={{
                    ...themeBasedSignupFormControl(theme),
                    // border: '1px solid rgb(250, 229, 255)',
                    // width: screenSize >= 576 ? "200px" : "100%",
                    maxWidth: "100%",
                    fontSize: "1.1rem",
                  }}
                />
              </div>
            </div>
            <div
              className='d-flex align-items-center justify-content-end mt-5'
              style={{
                paddingInlineEnd: "60px",
              }}
            >
              <button
                className='btn d-flex align-items-center justify-content-center px-3 gap-2'
                type='button'
                disabled={loading.updateBank}
                onClick={handleUpdateInvestorBank}
                style={{
                  ...customLoginButton,
                  minWidth: "112px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  letterSpacing: "0.02em",
                }}
              >
                {loading.updateBank ? (
                  <>
                    <span
                      className='spinner-border spinner-border-sm'
                      aria-hidden='true'
                      style={{
                        fontSize: "0.85rem",
                        height: "15px",
                        width: "15px",
                      }}
                    ></span>
                    <span role='status' className='ms-1'>
                      Updating ...
                    </span>
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>

            <hr className='mx-auto' style={{ width: "100%", maxWidth: "300px", marginBlock: "32px", color: theme === "light" ? "rgb(33, 37, 41)" : "rgb(134, 151, 168)" }} />

          <div
            className='mx-auto'
            // onSubmit={submitRegisterForm}
            style={{
              marginTop: "2.5rem",
              marginBottom: "3rem",
              // minWidth: '600px',
              width: "100%",
              maxWidth: "900px",
              // backgroundColor: theme === "dark" ? "rgba(90, 90, 90, .6)" : "rgb(198, 204, 227, .48)",
              backgroundImage: "linear-gradient(120deg, var(--theme-card-secondary-bg) 0%, var(--theme-card-primary-bg) 100%)",
              color: theme === "dark" ? "rgb(210, 210, 210)" : "rgb(53, 53, 53)",
              // border: "1px solid rgba(255,255,255,.15)",
              border: "1px solid",
              borderColor: "var(--theme-card-border)",
              borderRadius: ".5rem",
              padding: screenSize >= 576 ? "1.75rem 2rem 2.5rem 2rem" : "1.75rem 1.5rem 2.5rem 1.5rem",
              // maxWidth: '100%'
            }}
          >

            <div
              className='mt-0'
              style={{
                color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)",
                fontSize: "22px",
                fontWeight: "500",
                lineHeight: "1.15",
              }}
            >
              Additional Information
            </div>
            <div
              className='row w-100 mx-auto row-cols-sm-2 row-gap-4'
              style={{
                fontWeight: "400",
                marginTop: "2rem",
              }}
            >
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Occupation
                  {/* <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span> */}
                  {investorData && investorData?.occupation && investorData?.occupation?.length !== 0 ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <Select
                  className='basic-single'
                  classNamePrefix='select'
                  name='occupation'
                  defaultValue={""}
                  value={investorUpdateData?.occupation || ""}
                  onChange={updateInvestorData}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  options={staticData.occupations}
                  styles={{
                    multiValue: (provided) => ({
                      ...provided,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
                    }),
                    clearIndicator: (provided, state) => ({
                      ...provided,
                      color: state.isFocused
                        ? theme === "light"
                          ? "rgb(200,200,200)"
                          : "rgb(144, 144, 144)"
                        : theme === "light"
                          ? "rgba(240, 240, 240, .65)"
                          : "rgb(184, 184, 184)",
                      "&:hover": {
                        color: state.isFocused
                          ? theme === "light"
                            ? "rgb(240,240,240)"
                            : "rgb(105, 105, 105)"
                          : theme === "light"
                            ? "rgba(240, 240, 240, .85)"
                            : "rgb(153, 153, 153)",
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: theme === "dark" ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
                    }),
                    control: (provided, state) => ({
                      ...provided,
                      minHeight: "40px",
                      // width: '120px',
                      // maxWidth: '120px',
                      backgroundColor: theme === "dark" ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
                      borderColor: theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
                      color: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
                      borderRadius: ".375rem",
                      fontFamily: "inherit",
                      boxShadow: state.isFocused
                        ? `0 0 2px 1px ${theme === "light" ? "rgba(136, 136, 136, 0.5)" : "rgba(136, 136, 136, 0.5)"}` // e.g. a semi-transparent red ring
                        : "none",
                      "&:hover": {
                        borderColor: theme === "dark" ? "rgb(156, 155, 156)" : "rgb(174, 172, 175)",
                      },
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
                    }),
                    dropdownIndicator: (provided, state) => ({
                      ...provided,
                      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined,
                      transition: "all 0.2s ease",
                      color: state.isFocused
                        ? theme === "light"
                          ? "rgb(200,200,200)"
                          : "rgb(144, 144, 144)"
                        : theme === "light"
                          ? "rgba(240, 240, 240, .65)"
                          : "rgb(184, 184, 184)",
                      "&:hover": {
                        color: state.isFocused
                          ? theme === "light"
                            ? "rgb(240,240,240)"
                            : "rgb(105, 105, 105)"
                          : theme === "light"
                            ? "rgba(240, 240, 240, .85)"
                            : "rgb(153, 153, 153)",
                      },
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: theme === "dark" ? "rgba(0, 0, 0, 0.4)" : "rgba(240, 240, 240, .65)",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      // backgroundColor: theme === 'dark' ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
                      borderRadius: 4,
                      padding: 0,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: state.isSelected ? (theme === "light" ? "rgb(250,250,250)" : "rgb(240,240,240)") : theme === "light" ? "rgba(240, 240, 240, .95)" : "rgb(33,37,41)",
                      backgroundColor: state.isSelected
                        ? theme === "light"
                          ? "rgb(203, 110, 209)"
                          : "rgb(44, 106, 182)"
                        : theme === "light"
                          ? "rgb(107, 106, 138)"
                          : "rgb(230, 230, 230)",
                      fontWeight: "400",
                      "&:hover": {
                        cursor: "pointer",
                        backgroundColor: state.isSelected ? "" : theme === "light" ? "rgb(230, 230, 230)" : "rgb(200, 200, 200)",
                        color: state.isSelected ? "" : theme === "light" ? "rgb(33,37,41)" : "",
                      },
                    }),
                  }}
                />
              </div>
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Annual Income
                  {/* <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span> */}
                  {investorData && investorData?.annual_income && investorData?.annual_income !== undefined ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <input
                  className='form-control auth-form-control'
                  placeholder={"Enter Annual Income"}
                  name='annual_income'
                  value={investorUpdateData?.annual_income ? numberWithCommas(investorUpdateData?.annual_income) : ""}
                  onChange={updateInvestorData}
                  type='text'
                  style={{
                    ...themeBasedSignupFormControl(theme),
                    // border: '1px solid rgb(250, 229, 255)',
                    // width: screenSize >= 576 ? "200px" : "100%",
                    maxWidth: "100%",
                    fontSize: "1.1rem",
                  }}
                />
              </div>
              <div className='col-12 col-sm p-0 pe-sm-4 pe-md-5'>
                <div
                  className='ps-1 d-inline-flex align-items-center'
                  style={{
                    fontSize: ".9rem",
                    marginBottom: ".325rem",
                    columnGap: "10px",
                  }}
                >
                  Address
                  {/* <span className='' style={{ fontSize: ".875rem", color: theme === "light" ? "rgb(39, 102, 179)" : "rgb(222, 120, 230)" }}>
                    {"(PNG, JPG, JPEG, PDF, ZIP)"}
                  </span> */}
                  {investorData && investorData?.address && investorData?.address?.length !== 0 ? (
                    <CheckMarkIcon width={18} height={18} color={"rgb(16, 223, 126)"} />
                  ) : (
                    <WarningMarkIcon width={18} height={18} color='#ffc107' />
                  )}
                </div>
                <textarea
                  className='form-control auth-form-control'
                  value={investorUpdateData?.address}
                  onChange={updateInvestorData}
                  name='address'
                  placeholder='Your address'
                  style={{
                    height: "80px",
                    ...themeBasedSignupFormControl(theme),
                    // border: '1px solid rgb(250, 229, 255)',
                    // width: screenSize >= 576 ? "200px" : "100%",
                    maxWidth: "100%",
                    fontSize: "1.1rem",
                  }}
                />
              </div>
            </div>
            <div
              className='d-flex align-items-center justify-content-end mt-5'
              style={{
                paddingInlineEnd: "60px",
              }}
            >
              <button
                className='btn d-flex align-items-center justify-content-center px-3 gap-2'
                type='button'
                disabled={loading.updateInfo}
                onClick={handleUpdateInvestorInfo}
                style={{
                  ...customLoginButton,
                  minWidth: "112px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  letterSpacing: "0.02em",
                }}
              >
                {loading.updateInfo ? (
                  <>
                    <span
                      className='spinner-border spinner-border-sm'
                      aria-hidden='true'
                      style={{
                        fontSize: "0.85rem",
                        height: "15px",
                        width: "15px",
                      }}
                    ></span>
                    <span role='status' className='ms-1'>
                      Updating ...
                    </span>
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
            {/* {renderStep()} */}
          </div>
        </div>
        <div className='col-auto p-0'>
          <div
            className='text-center'
            style={{
              lineHeight: "1",
              fontSize: "1.2rem",
              color: "rgba(255,255,255,0.7)",
            }}
          >
            {t("app.login.form.power")}
          </div>
          <img
            className=''
            src={DcclLogo}
            alt='Logo'
            style={{
              width: "160px",
            }}
          />
        </div>
        {activeModal && (
          <DynamicOtpModal
            ref={dynamicModalRef}
            title={activeModal?.title}
            otpType={activeModal?.type}
            otpValue={otp}
            onChangeOtp={updateOtp}
            onConfirm={handleOtpModalSubmit}
            onClose={handleModalClose}
            loading={activeModal?.type === "email" ? loading.otpEmail : loading.otpMobile}
          />
        )}
      </div>
    </div>

    // </div>
  );
};

export default DocumentVerification;
